import { Grid, Stack } from '@mui/material';
import { VacancyInterviewStats } from 'types/vacancyStats';
import FunnelWidget from './FunnelWidget';
import InvitationsWidget from './InvitationsWidget';
import ScoresWidget from './ScoresWidget';
import PsychometricsWidget from './PsychometricsWidget';
import PriceWidget from './PriceWidget';
import ScoresTableWidget from './ScoresTableWidget';
import VacancySkillsWidget from './VacancySkillsWidget';

interface Props {
  stats: VacancyInterviewStats;
}

/**
 * Композиция дашборда. Воронка/приглашения считаются по всем кандидатам,
 * а scores/psychometrics/price — только по завершённым интервью с результатом
 * (у этих блоков своя подпись покрытия и пустое состояние).
 */
const VacancyStatsDashboard = ({ stats }: Props) => (
  <Stack spacing={3} sx={{ pb: 4, width: '100%', ml: '-12px !important', mr: '-12px !important' }}>
    {/* <VacancySkillsWidget /> */}

    <Grid container spacing={3} alignItems="stretch">
      <Grid item xs={12} md={6}>
        <FunnelWidget funnel={stats.funnel} invitations={stats.invitations} />
      </Grid>
      <Grid item xs={12} md={6}>
        {/* <InvitationsWidget invitations={stats.invitations} /> */}
        <ScoresWidget scores={stats.scores} />
      </Grid>
    </Grid>

    {/* <PsychometricsWidget psychometrics={stats.psychometrics} /> */}
    <ScoresTableWidget scores={stats.scores}/>
    <PriceWidget price={stats.price} />
  </Stack>
);

export default VacancyStatsDashboard;
